import { useEffect } from 'react';

import * as Sentry from '@sentry/browser';

import { DOMAIN } from 'data/constants';

export function useChatwoot(
  depositId: string,
  enabled: boolean,
  locale: string,
) {
  useEffect(() => {
    if (!enabled) return;

    try {
      const BASE_URL = `https://chat.${DOMAIN}`;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).chatwootSettings = {
        hideMessageBubble: false,
        position: 'right',
        locale,
        type: 'bubble',
      };

      const script = document.createElement('script');
      script.src = `${BASE_URL}/packs/js/sdk.js`;
      script.defer = true;
      script.async = true;
      script.onload = () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).chatwootSDK?.run({
          websiteToken: '7gTotJKEbXd5VoSrkSAgoPQD',
          baseUrl: BASE_URL,
        });
      };
      document.body.appendChild(script);

      const setChatwootUser = () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const chatwoot = (window as any).$chatwoot;
        if (!chatwoot || !depositId) return;

        chatwoot.setUser(`payment_${depositId}`, {
          name: `Payment ${depositId}`,
        });

        chatwoot.setCustomAttributes({
          deposit_id: depositId,
        });
      };

      window.addEventListener('chatwoot:ready', setChatwootUser);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((window as any).$chatwoot) {
        setChatwootUser();
      }

      return () => {
        window.removeEventListener('chatwoot:ready', setChatwootUser);
        script.remove();
        document
          .querySelectorAll('[class^="woot-"]')
          .forEach((el) => el.remove());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete (window as any).chatwootSDK;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete (window as any).$chatwoot;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete (window as any).chatwootSettings;
      };
    } catch (error) {
      Sentry.captureException(error);
    }
  }, [depositId, enabled, locale]);
}
